/**
 * reportingHelpers.js - the cleaning layer every Reporting chart goes through.
 *
 * The bid sheet carries junk ('(PICK ONE)', blanks) and several spellings of
 * the same value ('P. PROCESS' vs 'Paint Process'), so labels are normalised
 * here before anything is grouped or counted. safeSum also drops absurd
 * figures, which is what stops one bad cell blowing up a whole chart.
 */

export const DIRTY = new Set(['(PICK ONE)', '', 'null', 'undefined']);
export const cleanValue = (val) => {
  if (!val) return null;
  const v = String(val).trim();
  return DIRTY.has(v) ? null : v;
};
export const LABEL_MAP = {
  'P. PROCESS': 'Paint Process',
  'P.PROCESS': 'Paint Process',
  'S. PROCESS': 'Sealer Process',
  'SOFTW/PROCES': 'Software/Process',
  SOFTWARE: 'Software',
  SOLUTIONS: 'Solutions',
  SERVICES: 'Services',
  PROJECT: 'Project',
  EQUIPMENT: 'Equipment',
  PARTS: 'Parts',
  GENERAL: 'General',
  BUDGET: 'Budget',
  PROCESS: 'Process',
  IE: 'I/E',
  'SERVICES & SOLUTIONS': 'Services & Solutions',
  '(PICK ONE)': null,
};
export const cleanLabel = (val) => {
  const v = String(val || '').trim();
  if (DIRTY.has(v)) return null;
  if (v in LABEL_MAP) return LABEL_MAP[v];
  return v;
};
export const trunc = (s, n = 22) => (s && s.length > n ? s.slice(0, n - 1) + '…' : s);
export const getISOWeek = (d) => {
  const dt = new Date(d);
  dt.setHours(0, 0, 0, 0);
  dt.setDate(dt.getDate() + 3 - ((dt.getDay() + 6) % 7));
  const week1 = new Date(dt.getFullYear(), 0, 4);
  return Math.round(((dt - week1) / 86400000 - 3 + ((week1.getDay() + 6) % 7)) / 7) + 1;
};
export const CSV_BTN = {
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  padding: '4px 10px',
  borderRadius: 6,
  border: '1px solid #E8E8E8',
  background: '#fff',
  fontSize: 10,
  fontWeight: 600,
  color: '#666',
  cursor: 'pointer',
  fontFamily: 'Montserrat',
};

export const winRateColor = (r) => (r >= 70 ? '#1B5E20' : r >= 40 ? '#E65100' : '#B71C1C');
export const safeSum = (arr) =>
  arr.reduce((s, p) => {
    const v = parseFloat(p.quotedPrice || p.quoted_price || 0);
    return s + (isFinite(v) && v < 500000000 ? v : 0);
  }, 0);
